import Helpers from '../../../../common/helpers/Helpers';
import Constants from '../../../../common/constants/Constants';

export const saveInstrumentConfiguration = instrumentConfiguration => {
  return Helpers.post(`${Constants.INSTRUMENTS_URL}/configuration`, {}, instrumentConfiguration);
};

export const updateInstrumentConfiguration = instrumentConfiguration => {
  return Helpers.put(`${Constants.INSTRUMENTS_URL}/configuration`, {}, instrumentConfiguration);
};

export const getInstrumentConfiguration = instrumentId => {
  return Helpers.get(`${Constants.INSTRUMENTS_URL}/configuration/${instrumentId}`);
};
